import Joi from 'joi';
import { ElaasCriteriaOperatorType } from './ElaasCriteriaOperatorType';
import { ElaasIdentifierCriterion } from './ElaasIdentifierCriterion';

// This type is in the same module as ElaasConsequenceCriterion since otherwise we would create a circular dependency.
export type ElaasLogicalOperatorCriterion = {
  operator: ElaasCriteriaOperatorType;
  criteria: ElaasConsequenceCriterion[];
};

const logicalOperatorCriterionSchema = Joi.object({
  operator: Joi.string(),
  criteria: Joi.array(),
});

function isOfType(obj: unknown): obj is ElaasLogicalOperatorCriterion {
  return !logicalOperatorCriterionSchema.validate(obj).error;
}

export const ElaasLogicalOperatorCriterion = {
  isOfType,
};

export type ElaasConsequenceCriterion = ElaasIdentifierCriterion | ElaasLogicalOperatorCriterion;

const isIdentifierCriterion = (criterion: ElaasConsequenceCriterion): criterion is ElaasIdentifierCriterion =>
  ElaasIdentifierCriterion.isOfType(criterion);

const isLogicalOperatorCriterion = (criterion: ElaasConsequenceCriterion): criterion is ElaasLogicalOperatorCriterion =>
  isOfType(criterion);

export const ElaasConsequenceCriterion = {
  isIdentifierCriterion,
  isLogicalOperatorCriterion,
};
